import {effect, Injectable, signal, WritableSignal} from '@angular/core';
import {environment} from "src/environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Notification} from "src/app/interfaces/notification";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  api: string =`${environment.api}/notifications`;
  notifications: WritableSignal<Notification[]> = signal(this.readFromStorage());
  count: WritableSignal<number> = signal(0);
  FETCH_INTERVAL_MS = 5000;
  LOAD_COUNT: number = 10;

  constructor(private http: HttpClient) {
    effect(() => localStorage.setItem('notifications', JSON.stringify(this.notifications())));
    this.startInterval();
  }
  private startInterval(){
    setInterval(()=>this.fetchNotifications(this.LOAD_COUNT),this.FETCH_INTERVAL_MS)
  }
  fetchNotifications(limit: number = this.LOAD_COUNT){
    const params = new HttpParams().set('limit', limit);
    return this.http.get<Notification[]>(`${this.api}`, { params: params }).subscribe(res=> this.notifications.set(res));
  }
  getNotifications() {
    return this.notifications
  }
  readFromStorage(){
    const items = localStorage.getItem('notifications');
    return items? JSON.parse(items) : [];
  }
  readNotification(uuid: string) {
    return this.http.patch<Notification>(`${this.api}/${uuid}/read`, { observe: 'body' });
  }
  loadMore() {
    this.LOAD_COUNT += 10;
    this.fetchNotifications(this.LOAD_COUNT);
  }
}
